import { Dialog } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CircledPopUpFrame from '../Core/CircledPopUpFrame'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import ErrorIcon from '@material-ui/icons/Error'
import NewFillButton from '../Core/NewFillButton'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive'

export const CustomErrorPopup = ({ title, body, open, onCancel, type = 'error' }) => {
  const handleClose = () => {
    onCancel && onCancel()
  }

  const getPopUpIcon = type => {
    switch (type) {
      case 'error':
        return <ErrorIcon fontSize="large" className="red" />
      case 'information':
        return <NotificationsActiveIcon fontSize="large" className="blue" />
      default:
        return <ErrorIcon fontSize="large" className="red" />
    }
  }

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'white',
          opacity: 0.74,
        },
      }}
      fullWidth
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
      maxWidth={'xs'}
    >
      <CircledPopUpFrame onCancel={handleClose} circleHeader={<ElevatedCircle>{getPopUpIcon(type)}</ElevatedCircle>}>
        <div className="text-title blue textcenter margin-bottom-basic">{title}</div>
        <div className="text-body black textcenter">{body}</div>
        <NewFillButton onClick={handleClose}>OK</NewFillButton>
      </CircledPopUpFrame>
    </Dialog>
  )
}
